import { useEffect, useState } from "react";
import { useDashboardStore } from "../../../store/dashboardStore.js";
import moment from "moment";
import { Popover, Button, DatePicker } from "antd";
import WorldMap from "react-svg-worldmap";


import ActiveNowUser from "./activenowuser";
import OnlineNowUserList from "./onlinenowuserlist";
import TopCountryList from "./topcountrylist";

const { RangePicker } = DatePicker;

export default function Tranding() {
  const { topCountries, getTopCountries } = useDashboardStore();

  const [topCountriesFiltered, setTopCountriesFiltered] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [customDateRange, setCustomDateRange] = useState([]);
  const [dropdownVisible, setDropdownVisible] = useState(false);

  const predefinedDateRanges = [
    { label: "Today", value: "today" },
    { label: "Yesterday", value: "yesterday" },
    { label: "Last 7 Days", value: "last7days" },
    { label: "Last 1 Month", value: "last1month" },
    { label: "Last 3 Months", value: "last3months" },
    { label: "Last 6 Months", value: "last6months" },
    { label: "Last 365 Days", value: "last365days" },
  ];

  useEffect(() => {
    fetchTopCountries();
  }, [fromDate, toDate]);

  useEffect(() => {
    const filteredCountries = topCountries?.map((country) => ({
      country: country.countryCode,
      value: country.count,
    }));
    setTopCountriesFiltered(filteredCountries);
  }, [topCountries]);

  const fetchTopCountries = async () => {
    const payload = { fromDate, toDate };
    getTopCountries(payload);
  };

  const calculateDateRange = (rangeValue) => {
    const now = moment();
    let fromDate = null;
    let toDate = now.endOf("day").format("YYYY-MM-DD");

    switch (rangeValue) {
      case "today":
        fromDate = now.clone().startOf("day").format("YYYY-MM-DD");
        toDate = now.clone().endOf("day").format("YYYY-MM-DD");
        break;
      case "yesterday":
        fromDate = now
          .clone()
          .subtract(1, "day")
          .startOf("day")
          .format("YYYY-MM-DD");
        toDate = now
          .clone()
          .subtract(1, "day")
          .endOf("day")
          .format("YYYY-MM-DD");
        break;
      case "last7days":
        fromDate = now
          .clone()
          .subtract(7, "days")
          .startOf("day")
          .format("YYYY-MM-DD");
        break;
      case "last1month":
        fromDate = now
          .clone()
          .subtract(1, "month")
          .startOf("day")
          .format("YYYY-MM-DD");
        break;
      case "last3months":
        fromDate = now
          .clone()
          .subtract(3, "months")
          .startOf("day")
          .format("YYYY-MM-DD");
        break;
      case "last6months":
        fromDate = now
          .clone()
          .subtract(6, "months")
          .startOf("day")
          .format("YYYY-MM-DD");
        break;
      case "last365days":
        fromDate = now
          .clone()
          .subtract(365, "days")
          .startOf("day")
          .format("YYYY-MM-DD");
        break;
      default:
        break;
    }

    return { fromDate, toDate };
  };

  const handleRangeSelection = (value) => {
    const { fromDate, toDate } = calculateDateRange(value);
    setFromDate(fromDate);
    setToDate(toDate);

    setCustomDateRange([]);
    setDropdownVisible(false);
  };

  const handleCustomDateApply = () => {
    if (customDateRange?.length === 2) {
      setFromDate(customDateRange[0].format("YYYY-MM-DD"));
      setToDate(customDateRange[1].format("YYYY-MM-DD"));
    } else {
      setFromDate("");
      setToDate("");
    }
    setDropdownVisible(false);
  };

  const dropdownContent = (
    <div className="flex flex-col gap-2 p-3 bg-white rounded">
      {predefinedDateRanges.map((range) => (
        <div
          key={range.value}
          className="cursor-pointer hover:bg-gray-200 p-2 rounded"
          onClick={() => handleRangeSelection(range.value)}
        >
          {range.label}
        </div>
      ))}
      <div className="border-t pt-2 mt-2">
        <RangePicker
          onChange={(dates) => setCustomDateRange(dates)}
          value={customDateRange}
        />
        <div className="flex justify-end gap-2 mt-2">
          <Button type="primary" size="small" onClick={handleCustomDateApply}>
            Apply
          </Button>
          <Button size="small" onClick={() => setDropdownVisible(false)}>
            Cancel
          </Button>
        </div>
      </div>
    </div>
  );

  return (
    <>
      <div className="w-full flex flex-row justify-between gap-4">
        <div className="w-[50%]">
          <ActiveNowUser />
          <br />
          <br />
          <ActiveNowUser />
          <br />
          <br />
          <OnlineNowUserList />
        </div>
        <div className="w-[50%] py-6 bg-[#ffffff] px-6 rounded-2xl">
          <div className="w-full justify-between items-end flex">
            <div className="opacity-70 text-[#222222] text-2xl font-semibold  leading-loose">
              Top Countries
            </div>
            <Popover
              content={dropdownContent}
              trigger="click"
              placement="bottomLeft"
              open={dropdownVisible}
              onOpenChange={(visible) => setDropdownVisible(visible)}
            >
              <div className="bg-gray-100 border border-gray-300 rounded-lg p-3.5 w-max text-[#00000046] font-semibold">
                {fromDate && toDate ? (
                  <span className="flex gap-3">
                    From: {fromDate} To: {toDate}
                    <span
                      onClick={() => {
                        setFromDate("");
                        setToDate("");
                        setCustomDateRange([]);
                      }}
                      className="cursor-pointer"
                    >
                      X
                    </span>
                  </span>
                ) : (
                  "Select Date Range"
                )}
              </div>
            </Popover>
          </div>
          <div className="world-map h-[500px] w-full">
            <WorldMap
              className="map"
              color="#310048"
              value-suffix="people"
              size="responsive"
              data={topCountriesFiltered}
            />
          </div>
          <div>
            <div className="w-full bg-[#ffff] border-t border-[#e6e6e6] flex-col justify-start items-center gap-[33px] inline-flex">
              <div className="w-[100%] px-6 pt-8 flex flex-col gap-3">
                {topCountries?.map((item, index) => (
                  <TopCountryList
                    key={index}
                    countrycode={item?.countryCode}
                    countryname={item?.country}
                    percent={item?.percentage}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}








